/* istanbul ignore file */
/**
 * @todo Timestamp: https://jira.homeawaycorp.com/browse/SCRATCHPAD-1882
 */
import Avatar from '../../avatar/avatar';
import AvatarName from '../../avatar/avatar-name';
import React from 'react';
import './comment.less';

export default function Comment({
    text,
    user,
    timestamp
}) {
    const firstName = user && user.firstName;
    const lastName = user && user.lastName;
    const publicImageUrl = user && user.publicImageUrl;
    return (
        <div className="comment">
            <div className="comment__row">
                <Avatar
                    allowEmpty
                    className="comment__avatar"
                    firstName={firstName}
                    publicImageUrl={publicImageUrl}
                    sm
                />
                <div className="comment__content">
                    <AvatarName firstName={firstName} lastName={lastName}/>
                    <span className="comment__body">{text}</span>
                    <br />
                    <span className="comment__timestamp">{timestamp}</span>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/universal/tripboard/comments/components/comment.js